export const GENERAL_QUESTIONS = [
  {
    id: "A1",
    label: "Sector of your organization",
    options: [
      "Technology / SaaS",
      "Industry / Manufacturing",
      "Healthcare",
      "Financial services",
      "HR / Recruitment",
      "Logistics / Supply Chain",
      "Government / Public sector",
      "Other sector",
    ],
  },
  {
    id: "A2",
    label: "Number of employees",
    options: ["1-10", "11-50", "51-250", "251-1,000", "1,000+"],
  },
  {
    id: "A3",
    label: "In how many countries is your organization active?",
    options: ["1", "2-5", "6-10", "10+"],
  },
  {
    id: "A4",
    label: "Does your organization use AI systems?",
    options: [
      "Yes, developed internally",
      "Yes, via external vendors",
      "Both",
      "No (not yet)",
    ],
  },
  {
    id: "A5",
    label: "Number of AI systems in use (rough estimate)",
    options: ["1-2", "3-5", "6-10", "10+"],
  },
  {
    id: "A6",
    label: "Impact of AI on core processes",
    options: ["Supportive", "Important", "Critical to operations"],
  },
];

// Options are ordered best to weakest: index 0 = 2 points, 1 = 1 point, 2 = 0 points.
export const ERI_SECTIONS = [
  {
    id: "ethics",
    title: "Ethics",
    questions: [
      { n: 1, text: "Does your organization have formal ethical guidelines for AI?", options: ["Yes, fully implemented", "Limited / ad hoc", "No"] },
      { n: 2, text: "Are AI decisions evaluated for fairness and bias?", options: ["Always", "Sometimes", "Not"] },
      { n: 3, text: "Is there a point of contact for ethical AI issues?", options: ["Yes", "Partial / informal", "No"] },
      { n: 4, text: "Are stakeholders informed when AI affects them?", options: ["Yes, structurally", "Sometimes", "No"] },
      { n: 5, text: "Is ethics considered in the AI design phase?", options: ["Always", "Sometimes", "No"] },
    ],
  },
  {
    id: "operational",
    title: "Operational",
    questions: [
      { n: 6, text: "Are AI processes documented and repeatable?", options: ["Yes", "Partially", "No"] },
      { n: 7, text: "Are AI models tested for performance and reliability?", options: ["Regularly", "Sometimes", "Not"] },
      { n: 8, text: "Is there a clear separation between development and control of AI?", options: ["Yes", "Partially", "No"] },
      { n: 9, text: "Are AI incidents or errors recorded?", options: ["Yes", "Sometimes", "No"] },
      { n: 10, text: "Is there a plan to correct AI errors quickly?", options: ["Yes", "Limited", "No"] },
    ],
  },
  {
    id: "innovation",
    title: "Innovation",
    questions: [
      { n: 11, text: "Are new AI solutions tested for risk and effectiveness before deployment?", options: ["Always", "Sometimes", "No"] },
      { n: 12, text: "Is there budget or time for AI experiments?", options: ["Yes", "Limited", "No"] },
      { n: 13, text: "Are employees involved in improving AI systems?", options: ["Structurally", "Sometimes", "No"] },
      { n: 14, text: "Are lessons from previous AI projects reused?", options: ["Yes", "Sometimes", "No"] },
      { n: 15, text: "Is AI innovation reported to management?", options: ["Yes", "Sometimes", "No"] },
    ],
  },
  {
    id: "governance",
    title: "Governance",
    questions: [
      { n: 16, text: "Is there a formal AI governance owner or team?", options: ["Yes", "Partially", "No"] },
      { n: 17, text: "Does management regularly review AI decisions?", options: ["Always", "Sometimes", "No"] },
      { n: 18, text: "Is there a policy on conflicts of interest in AI use?", options: ["Yes", "Limited", "No"] },
      { n: 19, text: "Is AI independently evaluated or audited?", options: ["Yes", "Sometimes", "No"] },
      { n: 20, text: "Are there clear rules for data and model use?", options: ["Yes", "Limited", "No"] },
    ],
  },
  {
    id: "risk",
    title: "Risk & Preparedness",
    questions: [
      { n: 21, text: "Are AI risk assessments performed before implementation?", options: ["Yes", "Sometimes", "No"] },
      { n: 22, text: "Are privacy and compliance risks actively monitored?", options: ["Yes", "Sometimes", "No"] },
      { n: 23, text: "Is your organization prepared for regulation such as the EU AI Act?", options: ["Yes", "Partially", "No"] },
      { n: 24, text: "Are external reviews or audits considered?", options: ["Yes", "Sometimes", "No"] },
      { n: 25, text: "Do you see AI governance as a competitive advantage?", options: ["Yes", "Limited", "No"] },
    ],
  },
];

export const BANDS = [
  { min: 0, max: 39, label: "Attention required", tone: "red" },
  { min: 40, max: 69, label: "Developing", tone: "amber" },
  { min: 70, max: 100, label: "Established", tone: "green" },
];

export function computeResults(scored) {
  const sectionScores = ERI_SECTIONS.map((s) => {
    const pts = s.questions.reduce((sum, q) => sum + (scored[q.n] ?? 0), 0);
    return { id: s.id, title: s.title, pct: Math.round((pts / 10) * 100) };
  });
  const total = Math.round(
    (ERI_SECTIONS.flatMap((s) => s.questions).reduce((sum, q) => sum + (scored[q.n] ?? 0), 0) / 50) * 100
  );
  const band = BANDS.find((b) => total >= b.min && total <= b.max) || BANDS[0];
  const attention = ERI_SECTIONS.flatMap((s) =>
    s.questions.filter((q) => (scored[q.n] ?? 0) === 0).map((q) => ({ section: s.title, text: q.text }))
  );
  return { sectionScores, total, band, attention };
}
